function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { setGlobalStyle } from './react/theme';
var DEFAULT_THEME = {
  color: {
    icon: '#3c3c3c',
    accent: '#ffd400',
    primary: '#fdf8d9'
  }
};
var currentTheme = _objectSpread({}, DEFAULT_THEME);
var listeners = [];
export var THEMING = {
  getTheme: function getTheme() {
    return _cloneDeep(currentTheme);
  },
  setTheme: function setTheme() {
    var newTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // start with new object so we bust any memoized value for listeners and get a good value for reset as well
    currentTheme = _merge({}, DEFAULT_THEME, newTheme);
    setGlobalStyle(currentTheme);
    listeners.forEach(function (l) {
      return l(currentTheme);
    });
  },
  /**
   * @param {Function} listener function to call with new theme object if theme changes
   * @returns function to call for removing the listener (for cleanup)
   */
  addListener: function addListener(listener) {
    if (typeof listener === 'function') {
      listeners.push(listener);
    }
    return function () {
      listeners = _toConsumableArray(listeners.filter(function (fn) {
        return fn !== listener;
      }));
    };
  }
};

// simple deep cloning for theme purposes
var _cloneDeep = function cloneDeep(original) {
  if (!original) {
    return original;
  }
  var theClone = Array.isArray(original) ? [] : {};
  for (var key in original) {
    var value = original[key];
    theClone[key] = _typeof(value) === 'object' ? _cloneDeep(value) : value;
  }
  return theClone;
};

// merge from https://thewebdev.info/2021/03/06/how-to-deep-merge-javascript-objects/
var isObject = function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
};
var _merge = function merge(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (!sources.length) {
    return target;
  }
  var source = sources.shift();
  if (isObject(target) && isObject(source)) {
    for (var key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, _defineProperty({}, key, {}));
        }
        _merge(target[key], source[key]);
      } else {
        Object.assign(target, _defineProperty({}, key, source[key]));
      }
    }
  }
  return _merge.apply(void 0, [target].concat(sources));
};